import React from "react";
import { useDispatch } from "react-redux";

import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Slide,
  Typography,
} from "@material-ui/core";
import { deleteNotaIntegracion } from "../../../../actions/discapacidad/discapacidadActions";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const ModalDeleteIntegracion = (props) => {
  const dispatch = useDispatch();

  const onClickDeleteHandler = () => {
    dispatch(deleteNotaIntegracion(props.idNotaDelete, props.idSolicitud, props.close));
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={props.open}
      onClose={props.close}
      TransitionComponent={Transition}
      keepMounted
    >
      <DialogTitle>Confirmar Eliminación</DialogTitle>
      <DialogContent>
        <Typography>Seguro que desea eliminar la nota?</Typography>
        <div
          style={{
            marginTop: "2rem",
            marginBottom: "1rem",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-evenly",
          }}
        >
          <Button variant="contained" color="primary" onClick={props.close}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onClickDeleteHandler}
          >
            Confirmar
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
